export default __webpack_public_path__ + "static/media/TravelService.2be72b75.webp";